(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5263],{

/***/ 7654:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNumber = __webpack_require__(81763);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 81763:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 31140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9253);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46888);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3023);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75358);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14888);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86108);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23917);
/* harmony import */ var views_Info_components_ChartLoaders__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66631);
/* harmony import */ var state_swap_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5549);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99150);








// Calls setHoverValue and setHoverDate when part of chart is hovered
// Note: this NEEDs to be wrapped inside component and useEffect, if you plug it as is it will create big render problems (try and see console)
var HoverUpdater = function(param) {
    var locale = param.locale, payload = param.payload, setHoverValue = param.setHoverValue, setHoverDate = param.setHoverDate;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHoverValue(payload.value);
        setHoverDate(payload.time.toLocaleString(locale, {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        }));
    }, [
        locale,
        payload.value,
        payload.time,
        setHoverValue,
        setHoverDate
    ]);
    return null;
};
var getChartColors = function(param) {
    var isChangePositive = param.isChangePositive;
    return isChangePositive ? {
        gradient1: "#7fff00",
        gradient2: "#4cbb17",
        stroke: "#008080"
    } : {
        gradient1: "#f5f5dc",
        gradient2: "#ff0038",
        stroke: "#de1738 "
    };
};
var _obj;
var dateFormattingByTimewindow = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_4__/* .PairDataTimeWindowEnum.DAY */ .l.DAY, {
    hour: "2-digit",
    minute: "2-digit"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_4__/* .PairDataTimeWindowEnum.WEEK */ .l.WEEK, {
    month: "short",
    day: "2-digit"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_4__/* .PairDataTimeWindowEnum.MONTH */ .l.MONTH, {
    month: "short",
    day: "2-digit"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_4__/* .PairDataTimeWindowEnum.YEAR */ .l.YEAR, {
    month: "short",
    day: "2-digit"
}), _obj);
/**
 * Note: remember that it needs to be mounted inside the container with fixed height
 */ var LineChart = function(param) {
    var data = param.data, setHoverValue = param.setHoverValue, setHoverDate = param.setHoverDate, isChangePositive = param.isChangePositive, timeWindow = param.timeWindow;
    var ref = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)(), locale = ref.currentLanguage.locale;
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().theme;
    var colors = getChartColors({
        isChangePositive: isChangePositive
    });
    var dateFormatting = dateFormattingByTimewindow[timeWindow];
    if (!data || data.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Info_components_ChartLoaders__WEBPACK_IMPORTED_MODULE_3__/* .LineChartLoader */ .fn, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_7__/* .ResponsiveContainer */ .h, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(recharts__WEBPACK_IMPORTED_MODULE_8__/* .AreaChart */ .T, {
            data: data,
            margin: {
                top: 5,
                right: 0,
                left: 0,
                bottom: 5
            },
            onMouseLeave: function() {
                if (setHoverDate) setHoverDate(undefined);
                if (setHoverValue) setHoverValue(undefined);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "gradient",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "5%",
                                stopColor: colors.gradient1,
                                stopOpacity: 0.34
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "100%",
                                stopColor: colors.gradient2,
                                stopOpacity: 0
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_9__/* .XAxis */ .K, {
                    dataKey: "time",
                    axisLine: false,
                    tickLine: false,
                    tickFormatter: function(time) {
                        return time.toLocaleString(locale, dateFormatting);
                    },
                    minTickGap: 8
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_10__/* .YAxis */ .B, {
                    dataKey: "value",
                    axisLine: false,
                    tickLine: false,
                    domain: [
                        "auto",
                        "auto"
                    ],
                    hide: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_11__/* .Tooltip */ .u, {
                    cursor: {
                        stroke: theme.colors.textDisabled
                    },
                    contentStyle: {
                        display: "none"
                    },
                    formatter: function(tooltipValue, name, props) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HoverUpdater, {
                            locale: locale,
                            payload: props.payload,
                            setHoverValue: setHoverValue,
                            setHoverDate: setHoverDate
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_12__/* .Area */ .u, {
                    dataKey: "value",
                    type: "linear",
                    stroke: colors.stroke,
                    fill: "url(#gradient)",
                    strokeWidth: 2
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LineChart);


/***/ })

}]);